import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CircleIcon from "@mui/icons-material/Circle";

const values = [
  {
    title: "Web Development",
    description:
      "Our team has the skills and experience to deliver solutions that exceed your expectations.",
    bgColor: "#DEFCF9",
    titleColor: "#000",
    describeColor: "#000",
  },
  {
    title: "Mobile App Development",
    description:
      "Our focus is on delivering mobile apps that provide real value for our clients and their customers.",
    bgColor: "#EA8FEA",
    titleColor: "#000",
    describeColor: "#000",
  },
  {
    title: "Brand Development",
    description:
      "We ensure that the brand we develop for our clients truly reflects the unique qualities of their businesses.",
    bgColor: "#D61355",
    titleColor: "#fff",
    describeColor: "#fff",
  },
  {
    title: "Document Design & Printing",
    description:
      "We are dedicated to delivering a seamless experience, with quick turnaround times and attention to detail at every stage of the process. ",
    bgColor: "#FDFDBD",
    titleColor: "#000",
    describeColor: "#000",
  },
  {
    title: "Data Analysis & Survey",
    description:
      "We help in conducting market research, analyzing customer feedback and gaining insights into your business data.",
    bgColor: "#2C3333",
    titleColor: "#fff",
    describeColor: "#fff",
  },
  {
    title: "Infographics Design",
    description:
      "Our team of graphic designers and data experts are passionate about helping you communicate complex information in an engaging and visual way.",
    bgColor: "#537FE7",
    titleColor: "#fff",
    describeColor: "#fff",
  },
];

const ColorButton = styled(Button)(() => ({
  color: "#fff",
  width: 165,
  height: 45,
  fontWeight: 600,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#000",
  borderColor: "#000",
  "&:hover": {
    color: "#fff",
    backgroundColor: "#000",
    borderColor: "#000",
  },
}));

const Products = () => {
  return (
    <Box>
      <Box marginTop={{ xs: "25%", sm: "5%" }}>
        <Typography
          variant="h4"
          color="#000"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          {" "}
          Empowering {""}
          <Typography
            component={"span"}
            color="#33E68C"
            fontWeight={800}
            variant={"h4"}
          >
            your vision {""}
          </Typography>
          through our creativity.
        </Typography>
        <Typography
          variant={"body1"}
          textAlign={"left"}
          color={"#000"}
          fontWeight={500}
          padding={{ xs: "5% 1%", sm: "1% 3% 3% 0%" }}
        >
          We work closely with our clients to understand their needs and we
          carry them along at every stage of our service delivery.
        </Typography>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          width={"100%"}
          flexWrap={"wrap"}
        >
          {values.map((lists, id) => (
            <Box
              key={id}
              width={{ xs: "100%", sm: "31%" }}
              margin={{ xs: "5% 0%", sm: "2% 0%" }}
              data-aos={"fade-up"}
              component={Card}
              boxShadow={{ xs: 1, sm: 3 }}
              borderRadius={5}
              backgroundColor={lists.bgColor}
              padding={{ xs: "5%", sm: "2%" }}
            >
              <Typography
                variant={"h6"}
                fontWeight={700}
                textAlign={"left"}
                color={lists.titleColor}
              >
                {lists.title}
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={500}
                textAlign={"left"}
                paddingTop={"3%"}
                paddingBottom={"5%"}
                lineHeight={"1.625em"}
                color={lists.describeColor}
              >
                {lists.description}
              </Typography>
              <Box padding={{ xs: "10% 2% 1% 0%", sm: "20% 2% 1% 0%" }}>
                <ColorButton
                  component={"a"}
                  variant="outlined"
                  size="medium"
                  href={"/our-services"}
                  endIcon={
                    <CircleIcon
                      sx={{
                        color: "#33E68C",
                        "&:hover": {
                          color: "#fff",
                        },
                      }}
                    />
                  }
                >
                  Learn More
                </ColorButton>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Products;
